import React, { SyntheticEvent, useEffect, useRef } from "react";
import { useApolloClient } from "@apollo/client";
import { FormControl, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useLocalAnalyticsState } from "../../../graphql/hooks";
import { updateFunnelTimestamps } from "../../../common/AnalyticsHelpers";
import cx from "classnames";
import styles from "./DailyBadges.module.scss";

export const FunnelDateInput = () => {
    const client = useApolloClient();
    const { funnelTimestamps } = useLocalAnalyticsState();
    const startDateRef = useRef<any>(null);
    const endDateRef = useRef<any>(null);

    useEffect(() => {
        if (startDateRef && endDateRef) {
            if (funnelTimestamps.startTimestamp !== -1) {
                startDateRef.current.valueAsNumber =
                    funnelTimestamps.startTimestamp * 1000;
            } else {
                startDateRef.current.valueAsNumber = undefined;
            }
            if (funnelTimestamps.endTimestamp !== -1) {
                endDateRef.current.valueAsNumber =
                    funnelTimestamps.endTimestamp * 1000;
            } else {
                endDateRef.current.valueAsNumber = undefined;
            }
        }
    }, [startDateRef, endDateRef, funnelTimestamps]);

    return (
        <div className="d-flex text-inverse align-items-center">
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="start-date-tooltip">Start Date</Tooltip>}
            >
                <FormControl
                    className={cx("mt-0", styles.dateInput)}
                    type="date"
                    ref={startDateRef}
                    onInput={(event: SyntheticEvent) => {
                        const timeStamp =
                            // @ts-ignore
                            event.currentTarget.valueAsNumber / 1000;
                        updateFunnelTimestamps(client, {
                            ...funnelTimestamps,
                            startTimestamp: timeStamp
                        });
                    }}
                />
            </OverlayTrigger>
            <div className="mx-1">→</div>
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="end-date-tooltip">End Date</Tooltip>}
            >
                <FormControl
                    className={cx(styles.dateInput)}
                    type="date"
                    ref={endDateRef}
                    onInput={(event: SyntheticEvent) => {
                        const timeStamp =
                            // @ts-ignore
                            event.currentTarget.valueAsNumber / 1000;
                        updateFunnelTimestamps(client, {
                            ...funnelTimestamps,
                            endTimestamp: timeStamp
                        });
                    }}
                />
            </OverlayTrigger>
        </div>
    );
};
